import { useTopbar } from "./Topbar.hook";
import BasicButton from "../../../modules/common/components/BasicButton";
import { formatDate } from "../../../utilities/format";

interface TopbarProps {
  isAdmin: boolean;
}

export default function Topbar({ isAdmin }: TopbarProps) {
  const {
    models: { title, tokenDataLoading, expiryTime, isExpired },
    operations: { onRefreshCafe24Token, logout },
  } = useTopbar();

  return (
    <header className="h-topbar flex w-full items-center justify-between bg-black px-5 py-2 text-white">
      <p className="text-2xl font-bold">{title}</p>
      <div className="flex gap-1">
        {isAdmin && (
          <BasicButton
            text={
              !isExpired && !!expiryTime
                ? `카페24 토큰 갱신 (${formatDate(expiryTime, "MM.DD HH:MM")})`
                : "카페24 토큰 만료됨"
            }
            onClick={onRefreshCafe24Token}
            loading={tokenDataLoading}
            className="w-[300px]"
          />
        )}
        <BasicButton
          text="로그아웃"
          onClick={logout}
          variant="error"
          className="w-1/4"
        />
      </div>
    </header>
  );
}
